export const homeMapper = {
    title: "A Tecnologia que transforma",
    subtitle: "Soluções inteligentes em software, dados e tecnologia para transformar desafios em resultados concretos.",
};
